<template>
    <div>
        <b-table hover
                 sort-by="created_at"
                 :items="items"
                 :fields="fields"
                 id="invoice-shifts-table"
                 foot-clone
        >
            <template v-slot:foot(checked_in_time)="data">
                <strong>Invoice Total</strong>
            </template>
            <template v-slot:foot(start_time)="data">&nbsp;</template>
            <template v-slot:foot(checked_out_time)="data">&nbsp;</template>
            <template v-slot:foot(caregiver)="data">&nbsp;</template>
            <template v-slot:foot(activities)="data">&nbsp;</template>
            <template v-slot:foot(duration)="data">
                <strong>{{ invoiceHours }}</strong>
            </template>
            <template v-slot:foot(cost)="data">
                <strong>{{ moneyFormat(invoiceTotal) }}</strong>
            </template>
        </b-table>

        <b-row>
            <b-col>
                <small><strong>Disclaimer:</strong> {{ fraudWarning }}<br/>
                    <a href="#" @click.prevent="fraudModal = true">View Claims Fraud Warning Statement</a>
                </small>
            </b-col>
            <b-col class="text-right">
                <strong>Enter Initials:</strong>
                <input type="text" class="form-control-lg" style="width: 100px;" v-model="enteredInitials" />
                <b-button variant="success" size="lg" @click="submit()" :disabled="submitting"><i class="fa fa-spin fa-spinner" v-if="submitting"></i> Submit Invoice to LTC</b-button>
            </b-col>
        </b-row>

        <claims-fraud-warning-modal v-model="fraudModal" />
    </div>
</template>

<script>
    import FormatsDates from '../../mixins/FormatsDates';
    import FormatsNumbers from '../../mixins/FormatsNumbers';

    export default {
        name: "ClientInvoicePreview",
        mixins: [FormatsDates, FormatsNumbers],
        props: ['items', 'initials', 'fraudWarning'],

        data() {
            return {
                fraudModal: false,
                enteredInitials: '',
                submitting: false,
                fields: [
                    {
                        key: 'checked_in_time',
                        label: 'Date',
                        formatter: (value) => this.formatDateFromUTC(value),
                    },
                    {
                        key: 'start_time',
                        label: 'Start',
                        formatter: (value) => this.formatTimeFromUTC(value),
                    },
                    {
                        key: 'checked_out_time',
                        label: 'End',
                        formatter: (value) => this.formatTimeFromUTC(value),
                    },
                    {
                        key: 'caregiver',
                        label: 'Provider',
                        formatter: this.getNameFromObj,
                    },
                    {
                        key: 'activities',
                        label: 'Services',
                        formatter: this.implodeActivities,
                    },
                    {
                        key: 'duration',
                        label: 'Hours',
                        formatter: this.numberFormat,
                    },
                    {
                        key: 'cost',
                        label: 'Total',
                        formatter: (value) => this.moneyFormat(value),
                    },
                ]
            }
        },

        computed: {
            invoiceHours() {
                return this.items.reduce((carry, item) => carry + item.duration, 0);
            },
            invoiceTotal() {
                return this.items.reduce((carry, item) => carry + item.cost, 0);
            }
        },

        methods: {
            getNameFromObj(object) {
                return object ? object.name : 'N/A';
            },
            implodeActivities(array) {
                return array.map(item => this.getNameFromObj(item)).join(', ');
            },
            async submit() {
                if (this.initials.toUpperCase() !== this.enteredInitials.toUpperCase()) {
                    alert('You must enter your initials.  Expecting: ' + this.initials);
                    return;
                }

                this.submitting = true;

                let form = new Form({
                    shifts: this.items.map(item => item.id),
                });

                try {
                    await form.post('/invoice-history');
                }
                catch (e) {
                    this.submitting = false;
                }
            }
        }
    }
</script>
